// extracted by mini-css-extract-plugin
export default {"text_block":"policy_text_block__ETOR4","title":"policy_title__q9EV6","bold":"policy_bold__GQ3cX"};